import React, { createContext, useContext, useMemo, useState } from "react";

const ACTIVE_CASE_STORAGE_KEY = "activeCaseNumber";

const CaseContext = createContext({
  activeCaseNumber: "",
  setActiveCaseNumber: () => {},
});

export const CaseProvider = ({ children }) => {
  const [activeCaseNumber, setActiveCaseNumberState] = useState(() => {
    return localStorage.getItem(ACTIVE_CASE_STORAGE_KEY) || "";
  });

  const setActiveCaseNumber = (nextValue) => {
    if (nextValue) {
      localStorage.setItem(ACTIVE_CASE_STORAGE_KEY, nextValue);
      setActiveCaseNumberState(nextValue);
    } else {
      localStorage.removeItem(ACTIVE_CASE_STORAGE_KEY);
      setActiveCaseNumberState("");
    }
  };

  const value = useMemo(
    () => ({
      activeCaseNumber,
      setActiveCaseNumber,
    }),
    [activeCaseNumber]
  );

  return <CaseContext.Provider value={value}>{children}</CaseContext.Provider>;
};

export const useCase = () => useContext(CaseContext);
